import React from "react";
import { ICourseData } from "../dto/ICourseData";

interface ICourseCardProps {
    course: ICourseData;
    highlighted?: boolean;
}

export default function CourseCard({ course, highlighted }: ICourseCardProps) {
    console.log(course)
    return (
        <div className={`course-card${highlighted ? " course-card--highlighted" : ""}`}>
            <div className="course-card__inner">
                <h3 className="course-card__title">{course.Text}</h3>
                <div className="course-card__footer">
                    
                        <div className="course-card__meta">
                            <span className="course-card__icon course-card__icon--graduation" aria-hidden="true"></span>
                            {course.CourseTime && (
                            <span className="course-card__time">Tid: {course.CourseTime} min</span>
                            )}
                        </div>
                    
                    {course.Url && (
                        <a href={course.Url} className="course-card__link" target="_blank" rel="noopener noreferrer">
                            {course.UserHasCourse ? "Starta kurs" : "Läs mer om kursen"}
                            <span className="course-card__arrow" aria-hidden="true"></span>
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}
